export default __webpack_public_path__ + "static/media/1.8412c845.png";